import { render, staticRenderFns } from "./shopHeader.vue?vue&type=template&id=603cf3fd&scoped=true&"
import script from "./shopHeader.vue?vue&type=script&lang=js&"
export * from "./shopHeader.vue?vue&type=script&lang=js&"
import style0 from "./shopHeader.vue?vue&type=style&index=0&id=603cf3fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603cf3fd",
  null
  
)

export default component.exports